import React, { Component } from "react";
import _ from "lodash";
import { getSideName } from "./../common/sideNameBuilder";

class Matches extends Component {
  render() {
    const roundMatches = _.chain(this.props.matches)
      .groupBy("round")
      .map((value, key) => ({ round: key, matches: value }))
      .orderBy("round", "desc")
      .value();

    return (
      <div className="mt-4 container-md">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center">Matches:</h2>
            <table className="table table-hover table-sm">
              <tbody>
                {roundMatches.map((roundMatch) => {
                  return (
                    <React.Fragment key={roundMatch.round}>
                      <tr key={roundMatch.round}>
                        <td colSpan="4" className="text-center table-primary">
                          <h5>Round {roundMatch.round} matches</h5>
                        </td>
                      </tr>
                      {roundMatch.matches.map((m) => {
                        return (
                          <tr key={m.matchId}>
                            <th>{m.court}:</th>
                            <td className="text-end">{getSideName(m.side1)}</td>
                            <td className="text-center align-middle">{m.score || "vs"}</td>
                            <td className="text-start">{getSideName(m.side2)}</td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default Matches;
